@if (component) {
<div class="_content w-6 va-t"
     [class._hidden]="isNotVisible()">
    <div class="flex flex-column flex-justify-between height-100 overflow-auto"
         #scrollable>
        @if (parent) {
        <div class="flex flex-middle p-t p-b p-l p-r b-b b-col-5">
            <button class="inline-flex flex-middle"
                    type='button'
                    (click)="back()">
                <i class="_submenu-header-icon icon-arrow-left"></i>
            </button>
            <p class="_submenu-header-title col-1 h3 w-12 center">{{ component.text }}</p>
        </div>
        }
        @for (item of component.menu; track $index) {
        @if (item.type === EMenuItemType.menu) {
        <button class="p-t p-l p-r p-b b-b b-col-5 flex flex-middle flex-justify-between w-12"
                (click)="menuClick($index)"
                type="button">
            <span class="s1 col-1"
                  *iCms="'text' of item">
            </span>
            <i class="_menu-item-icon inline-flex flex-middle icon-chevron-right"></i>
        </button>
        }
        @if(item.type === EMenuItemType.link) {
        <a class="flex flex-middle p-t p-l p-r p-b b-b b-col-5 s1 col-1"
           [routerLink]="item?.link">
            <span *iCms="'text' of item"></span>
            <!-- dummy icon to make it same height as other type elements -->
            <i style="opacity: 0;"
               class="_menu-item-icon icon-chevron-right"></i>
        </a>
        }
        @if(item.type === EMenuItemType.listOfLinks) {
        <button class="p-t p-b b-col-5 p-l p-r flex flex-middle flex-justify-between w-12"
                (click)="toggleService.toggle([uid, $index])"
                type="button">
            <span class="s1 col-1"
                  *iCms="'text' of item">
            </span>
            <i class="_menu-item-icon icon-chevron-down"
               [toggleClass]="'_rotate'"
               [toggleClassBy]="toggleService.getState([uid, $index])"></i>
        </button>
        <hide-up class="b-b b-col-5 p-l p-r"
                 [open]="toggleService.getState([uid, $index])">
            <ul>
                @for (link of item.listOfLinks; track $index) {
                <li [class.m-t]="!$first"
                    [class.m-b]="$last">
                    <a class="col-11 p1"
                       [routerLink]="link.url"
                       *iCms="'text' of link">
                    </a>
                </li>
                }
                @if(item.buttonCopy && item.link){
                <li class="m-b">
                    <a [routerLink]="item.link"
                       class="col-1"
                       [buttonStyle]="'text-button'">
                        <span *iCms="'buttonCopy' of item"></span>
                    </a>
                    }
            </ul>
        </hide-up>
        }
        }
        <ng-content />
    </div>
</div>
<div class="_children w-6">
    @for (item of menusWithChildren; track $index) {
    <div class="_child"
         [toggleClass]="'_active'"
         [toggleClassBy]="toggleService.getState([parentId, item.index])">
        <page-off-canvas-menu [component]="item"
                              [level]="level + 1"
                              [parent]="component"
                              [parentId]="parentId + item.index"
                              [toggleId]="[parentId, item.index]" />
    </div>
    }
</div>
}